import React, { useState } from 'react'
import {
    Box,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'

import { EzFolioLeadsPipelineTab } from './EzFolioLeadsPipelineTab'
import { EzFolioApplicationWorkbookTab } from './EzFolioApplicationWorkbookTab'
import { EzFolioSignableDocsTab } from './EzFolioSignableDocsTab'
import { PropertyConfigBundleWizard } from './PropertyConfigBundleWizard'

const LEADS_PIPELINE_TAB = 0
const APPLICATION_WORKBOOK_TAB = 1
const SIGNABLE_DOCS_TAB = 2

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(1.5, 2),
    },
    header: {
        marginBottom: theme.spacing(1.5),
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
    },
    titleIcon: {
        width: 36,
        height: 36,
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.primary.main + '14',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.primary.main,
        flexShrink: 0,
    },
    subtitle: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        marginTop: theme.spacing(0.25),
    },
    tabs: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(2),
    },
    tabPanel: {
        minHeight: 200,
    },
}))

export const EzFolioConfigurationsPage = () => {
    const classes = useStyles()
    const [activeTab, setActiveTab] = useState(LEADS_PIPELINE_TAB)

    return (
        <Box className={classes.root}>
            <Box className={classes.header}>
                <Box className={classes.titleRow}>
                    <Box className={classes.titleIcon}>
                        <SettingsIcon fontSize="small" />
                    </Box>
                    <Box>
                        <Typography variant="h5" component="h1">
                            Configurations
                        </Typography>
                        <Typography className={classes.subtitle}>
                            Org - Level Configurations
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Tabs
                value={activeTab}
                onChange={(_, value) => setActiveTab(value)}
                className={classes.tabs}
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab label="Leads Pipeline" />
                <Tab label="Application Workbook" />
                <Tab label="Signable Docs" />
            </Tabs>

            <Box className={classes.tabPanel}>
                <PropertyConfigBundleWizard />
                {activeTab === LEADS_PIPELINE_TAB && (
                    <EzFolioLeadsPipelineTab />
                )}
                {activeTab === APPLICATION_WORKBOOK_TAB && (
                    <EzFolioApplicationWorkbookTab />
                )}
                {activeTab === SIGNABLE_DOCS_TAB && <EzFolioSignableDocsTab />}
            </Box>
        </Box>
    )
}
